export default "__VITE_ASSET__4e78a65b__"